import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController, ModalController, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-register-country',
  templateUrl: './register-country.page.html',
  styleUrls: ['./register-country.page.scss']
})
export class RegisterCountryPage implements OnInit {
  constructor(
    public modalController: ModalController,
    public translate: TranslateService,
    public loadingController: LoadingController,
    public platform: Platform,
    public storage: Storage,
    public router: Router
  ) {}
  ev: any
  installEvent: any = null
  public storage_user: Storage | null = null

  ngOnInit(): void {
    window.addEventListener('beforeinstallprompt', (e) => {
      this.installEvent = e
    })
  }

  installByUser() {
    console.log(this.installEvent)
    if (this.installEvent) {
      this.installEvent.prompt()
      this.installEvent.userChoice.then((rta: any) => {
        if (rta.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt')
        } else {
          console.log('User dismissed the A2HS prompt')
        }
      })
    }
  }

  async selectCountry(country: string) {
    this.translate.use(country)
    localStorage.setItem('country', country)

    await this.modalController.dismiss().then(() => {
      this.storage.set(environment.localStorage, null)
      this.storage.set('status_log', 0)
      this.storage.set('menu', [])
      this.router.navigate(['login'])
    })
    await this.presentLoadingWithOptions()
    if (this.platform.is('desktop')) {
      this.installByUser()
    }
    console.log('Esto esta en storage: ', localStorage.getItem('country'))
  }

  async presentLoadingWithOptions() {
    const loading = await this.loadingController.create({
      spinner: 'circles',
      duration: 1000,
      message: 'Cargando formulario...',
      translucent: true,
      cssClass: 'custom-class custom-loading',
      backdropDismiss: true
    })
    await loading.present()

    await loading.onDidDismiss()
  }

  async closeModal() {
    await this.modalController.dismiss()
  }
}
